import React, { useState, useEffect } from "react";
import {
    withStyles,
    makeStyles,
    createStyles,
    useTheme,
} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { Paper } from '@mui/material';
import Grid from "@material-ui/core/Grid";
import { BreadcrumbPage } from "../../shared";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { getRequest } from "../../services/ApiServices";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
const useStyles = makeStyles((theme) => ({
    menuBox: {
        color: "#fff",
        fontFamily: "Bai Jamjuree, sans-serif !important",
    },
    navListItem: {
        "& .mactive": {
            backgroundColor: "#ff4717",
        },
    },
    btnStyle1: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginLeft: "500px",
    },
    btnStyle2: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "4px 22px",
        marginRight: "8px"
    },
    btnStyle3: {
        borderRadius: "8px",
        border: "2px solid #ff4717",
        boxShadow: "2px 2px 4px 2px #dadada",
        color: "#ffffff",
        background: "#ff4717 !important",
        textTransform: "capitalize",
        padding: "8px 300px",
        position: "absolute",
        marginLeft: "210px",
    },
    blinktext: {
        animation: "blinker 1s step-start infinite",
        color: "#FF4717"

    },
    link: {
        textTransform: "capitalize",
        color: "#ff4717 ",
        fontSize: "20px",
        textDecoration: "none",
        background: "none",
        border: "none",
        // marginLeft: "5px",
        "padding-right": "27px",
        // width: "12px",
        // height: "5px",
        '&:hover': {
            "text-decoration": "underline",
            cursor: "pointer",
            background: "none",
        }

    },
    paper: {
        padding: theme.spacing(2),
        textAlign: "center",
        color: theme.palette.text.secondary,
    },
    heading: {
        textAlign: "center",
        fontSize: "30px",
        fontWeight: "bold"
    },
    heading1: {
        padding: "1px",
        textAlign: "center",
        fontWeight: "bold"
    },
    heading2: {
        padding: "3px",
        textAlign: "center",
        fontWeight: "bold",
        color: "#ff4717 ",
    }, gallerySlider: {
        "& .image-gallery .image-gallery-icon:hover svg": {
            color: "#1a1a31",
        },
        "& .image-gallery .image-gallery-left-nav ": {
            left: "-50px",
        },
        "& .image-gallery .image-gallery-right-nav ": {
            right: "-50px",
        },
        "& .image-gallery .image-gallery-bullets ": {
            bottom: "-40px",
        },
        "& .image-gallery .image-gallery-bullets .image-gallery-bullet": {
            boxShadow: "0 0 0 #1a1a31",
            padding: "6px",
            margin: "0 10px",
            border: "1px solid #1a1a31",
        },
        "& .image-gallery .image-gallery-bullets .image-gallery-bullet.active": {
            background: "#1a1a31",
        },
    },

}));

export default function BunkerMaster() {
    const classes = useStyles();
    const BreadcrumbList = [{ name: "Bunker Master", url: "" }];
    
    useEffect(() => {
        if (getCookie('bM_ACCESS_STATUS') == "Requested") {
            ToastError("Your request Approval is awaiting ");
        } 

    }, []);

    const handleClose1 = () => {
        ////
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL +
            `User/RequestBMAccess`;
        getRequest(url)
        ToastError("Bunker master access requested");
    }

    var items = [
        {
            name: <img src="/assets/images/BM-Request-bg.jpg"></img>,

        },
        {
            name: <img src="/assets/images/BM-request-bg-1.jpg"></img>,

        },
        {
            name: <img src="/assets/images/BM-request-bg-2.jpg"></img>,
        },
        {
            name: <img src="/assets/images/BM-request-bg-3.jpg"></img>,
        }
    ]

    function Item(props) {
        return (
            <Paper >
                <div className="minheight600">{props.item.name}</div>
            </Paper>
        )
    }

    return(
        <div>
            <Box component="main" px={3} display="flex">
                <Grid container>
                    <Grid item xs={12} sm={12}>
                        <Box display="dlock">
                            <BreadcrumbPage rows={BreadcrumbList} />
                        </Box>
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Typography id="modal-modal-title" variant="h6" component="h2" className={classes.heading}>
                    Welcome to Bunker Master
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
                    To request a Bunker Master Access  <Button className={classes.link} onClick={handleClose1}>Click here</Button>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
                    or know more about Bunker Master Access latest features
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading2}>
                    C0<sub>2</sub> Calculations
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
                    This Module performs Co<sub>2</sub> related Calculations
                </Typography>

                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
                    {/* <img className="maxwidth50" src="/assets/images/VLSFO-1.jpg"></img> */}
                    {/* <Carousel
                NavButton={({ onClick, className, style, next, prev }) => {
                  // Other logic

                  return (
                    <Button onClick={onClick} className={className} style={style}>
                      {next && "Next"}
                      {prev && "Previous"}
                    </Button>
                  )
                }}
              >
                
              </Carousel> */}
                    {/* <Carousel
                 fullHeightHover={false}     // We want the nav buttons wrapper to only be as big as the button element is
                 navButtonsProps={{          // Change the colors and radius of the actual buttons. THIS STYLES BOTH BUTTONS
                     style: {
                         backgroundColor: '#e53c1f',
                         borderRadius: 0
                     }
                 }} 
                 navButtonsWrapperProps={{   // Move the buttons to the bottom. Unsetting top here to override default style.
                     style: {
                         bottom: '0',
                         top: 'unset'
                     }
                 }} 
                 NextIcon='>'             // Change the "inside" of the next button to "next"
                 PrevIcon='<'
                 className="bunkerCarousel"
              > */}
                    <div className={classes.paper + " scrollBar"} style={{ height: "550px", overflow: "auto" }}>
                        {
                            items.map((item, i) => <Item key={i} item={item} />)
                        }
                    </div>
                    {/* </Carousel> */}
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }} className={classes.heading1}>
                    To request a Bunker Master Access
                </Typography>
                {/* <Button className={classes.btnStyle1}onClick={handleClose}>Cancel</Button> */}
                <Button className={classes.btnStyle3} onClick={handleClose1} autoFocus>
                    Request For Bunker Master Access
                </Button>
            </Box>

        </div>
    );
}